<template>
  <div class="row" v-if="visible">
    <div class="categories-scroll">
      <a 
        v-bind:class="{active: selectedAlbum}"
        @click="setAlbumPhotos">
        {{ $t('events.album') }}
        <span>
          ({{ currentAlbum.photos.length | toNumberFormat }})
        </span>
      </a>
      <hr />
    </div>
  </div>
</template>

<script>
import Album from "../models/Album"

export default {
  name: "EventAlbums",
  props:{
    visible: {
      type: Boolean
    },
    album: {
      type: Object
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      albums: [],
      selectedAlbum: false,
      currentAlbum: new Album()
    }
  },  
  mounted() {
    this.currentAlbum = this.album;
    this.$root.$on('addPhotoToAlbum', this.addPhotoToAlbum);
    this.$root.$on('removePhotoFromAlbum', this.removePhotoFromAlbum);
  },
  methods: {
    setAlbumPhotos() {
      this.selectedAlbum = true;
      this.$emit('setAlbum', this.currentAlbum);
    },
    addPhotoToAlbum(photo) {
      this.currentAlbum.photos.push(photo);
    },
    removePhotoFromAlbum(photo) {
      const index = this.currentAlbum.photos.findIndex((el) => {
        return (el.id == photo.id)
      });

      if(index >= 0) {
        this.currentAlbum.photos.splice(index, 1);
      }
    }
  },
  watch: {
    active(newVal) {
      if(!newVal) {
        this.selectedAlbum = false;
      }
    },
    album(newVal, oldVal) {
      if(newVal !== oldVal) {
        this.currentAlbum = newVal;
      }
    }
  },  
};
</script>

<style lang="scss" scoped>
</style>
